import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';

const SiteCommandInterface = ({ mcadexinterface, site, config, measurements, userLevel, main_callback }) => {

    // Näytetään site command interface ainoastaan jos sitella on vähintään yksi mcadex. Pelkillä m2exillä ei tarvetta komentoikkunalle
    var hasAtLeastOneMcadex = (site['devices'].find((element) => element['type'] === 'mcadex')) === undefined ? false : true;

    //console.log('siteconfig - test', hasAtLeastOneMcadex)

    //console.log('siteconfig - commandinterface', site)
    let siteConfig = site;//TURHA config.find(x => x['site'] === site);
    var siteMacs = siteConfig['devices'].map(x => x['mac']);
    //console.log('siteconfig', siteConfig)
    //console.log('siteconfig - macs', siteMacs)
  
    const [ depolStatusOn, setDepolStatusOn ] = useState(false);
    const [ cycle, setCycle ] = useState(false);
    const [ initialized, setInitialized ] = useState(false);
  
    // Nämä talteen
    const [ depolOfftime, setDepolOfftime ] = useState(0); 
    const [ instantOfftime, setInstantOfftime ] = useState(0); 
    const [ offtime, setOfftime ] = useState(0); // Tallentuu myös ESPille
    const [ ontime, setOntime ] = useState(0);   // Tallentuu myös ESPille
  
    // initialize
    if (!initialized && measurements != 0) {
      //console.log('site initialize', measurements)
  
      // Otetaan siten ensimmäiseltä devicelta tiedot, joilla alustetaan
      let siteMeasurement = measurements[siteMacs[0]];
      //console.log('site initialize device', siteMeasurement)
  
      if (siteMeasurement === undefined) {
        //console.log(siteMeasurement === undefined)
  
        return;
      }

 
      // Depol - Jos mittauksessa tullut mtype=dep tai mtype=end(depoltestin viimeinen virraton potentiaalimittaus)
      setDepolStatusOn( (siteMeasurement != undefined && (siteMeasurement['mtype'] == 'dep' || siteMeasurement['mtype'] == 'end')) ); //TODO: pois täältä
      // Interrupt - Jos mittauksessa output=remoff
      //setInterrupt( (measurements['output'] == 'remoff') ? 0 : 1 );
  
      // Cycling - mittauksessa output=cycling
      setCycle( (siteMeasurement['output'] === 'cycling') );
  
      // On ja offtime
      setOntime( (siteMeasurement['ontime']) ? siteMeasurement['ontime'] : 0)
      setOfftime( (siteMeasurement['offtime']) ? siteMeasurement['offtime'] : 0)
  
  
      // Alustetaan configista löytyvästä rekisteridatasta
      setDepolOfftime( (siteConfig['depolinstantofftime'] ? siteConfig['depolinstantofftime'] : 0) );
      setInstantOfftime( (siteConfig['instantofftime'] ? siteConfig['instantofftime'] : 0) );
    
    
  
  
      setInitialized(true);
    }

    
    const sendCommand = (mac, command, value) => {
        main_callback("sendcommand", "commandinterface", {mac,command,value});
    }


    // Lähettää komennon Siten kaikille deviceille peräjälkeen (pitäisi olla riittävän nopea)
    const sendCommandToAllDevices = (command, value, save=false) => {
      siteMacs.forEach(mac => {
        sendCommand(mac, command, value);      
      })
  
  
  
        
    };
  
    // Site kohtaiset tallennukset
    const saveToServer = (command, value) => {
      let parameterToSave = `${site} ${command} ${value}`;
      console.log('Heippa lähetetään', parameterToSave)
      main_callback(parameterToSave);
    }
  
    
  
    // Blurit lähetetään kun input-kentästä hypätään pois
    const blurOfftime = () => {
      sendCommandToAllDevices('offtime', offtime);
    }
  
    const blurOntime = () => {
      sendCommandToAllDevices('ontime', ontime);
    }
  
    const doDepol = (checked) => {
      //siteMacs.forEach(mac => {
      console.log('doDepol', checked, depolStatusOn)
      if (checked) {
        sendCommandToAllDevices('depol', depolOfftime);
      }
      else {
        sendCommandToAllDevices('depol', 0);
      }
        
      //});
  
      //setDepolStatusOn(!depolStatusOn);    
      setDepolStatusOn(checked);    
    }
  
    const doInstantOff = () => {
      //siteMacs.forEach(mac => {
        console.log('doInstantOff')
        //if (depolStatusOn) {
          sendCommandToAllDevices('instoff', instantOfftime );
        //}
      //});
    }
  
    const doCycle = (checked) => {
      //let newCycle = (cycle === 0) ? 1 : 0;
      //setCycle(newCycle);
      let newCycle = cycle ? 0 : 1;
      setCycle(newCycle ? true : false);
  
      sendCommandToAllDevices('cycle', newCycle);
    }
  
    // Depol - Jos mittauksessa tullut mtype=dep tai mtype=end(depoltestin viimeinen virraton potentiaalimittaus)
    //setDepolStatusOn( (measurements['mtype'] == 'dep' || measurements['mtype'] == 'end') );  
  
    // Ei näytetä komentointerfacea jos sitella on ainoastaan m2exiä. Mikäli yksik8in Mcadex -> näytetään.
    if (mcadexinterface && userLevel > 1) {
      return (
        <>
            {/*<Table striped bordered hover info="true">*/}
            <Table bordered hover info="true">
              <thead>
                <tr>
                  <th>Depol</th>
                  <th>Depol instant offtime (ms)</th>
                  <th>Instant off</th>              
                  <th>Instant offtime</th>              
                  <th>Cycle</th>
                  {/*
                  <th>Off time</th>
                  <th>On time</th>
                  */}
              </tr>
              </thead>
    
              <tbody>
                <td>
                    <BootstrapSwitchButton
                        size="md"
                        checked={depolStatusOn}
                        onstyle={'primary'}
                        offstyle="info"
                        style="w-75"
                        onChange={(checked) => {doDepol(checked)}}
                        >
                    </BootstrapSwitchButton>
                </td>
    
    
    {/*
                <td>
                  <button onClick={() => { 
                    doDepol();
                  }}>{!depolStatusOn ? 'Start' : 'Stop'}</button>
                </td>
                */}
                <td>
                  <input class="h-25" value={depolOfftime} type="number" decimal onChange={(event) => { setDepolOfftime(event.target.value); saveToServer('depolinstantofftime', event.target.value); }} min='0' max='255' />             
                </td>
                <td>
                  <button type="button" class="btn btn-primary"
                      onClick={() => {
                      doInstantOff();
                    }}>Start
                  </button>
                </td>
                <td>
                  <input value={instantOfftime} type="number" decimal onChange={(event) => { setInstantOfftime(event.target.value); saveToServer('instantofftime', event.target.value); }} min='0' max='255' />             
                </td>
                <td>
                <BootstrapSwitchButton
                        size="md"
                        checked={cycle}
                        onstyle={'primary'}
                        offstyle="info"
                        style="w-75"
                        onChange={(checked) => {doCycle(checked)}}
                        >
                    </BootstrapSwitchButton>
    {/*
                  <button onClick={() => {  
                    doCycle();
                  }}>{(cycle === 0) ? 'Start' : 'Stop'}</button>      
                */}                      
                </td>
                {/* Poistettu Amin pyynnöstä näkyvistä
                <td>
                  <input value={offtime} type="number" decimal onChange={(event) => { setOfftime(event.target.value) }} onBlur={blurOfftime} min='0' max='255' />             
                </td>
                <td>
                  <input value={ontime} type="number" decimal onChange={(event) => { setOntime(event.target.value) }} onBlur={blurOntime} min='0' max='255' />                           
                </td>
              */}
              </tbody>
    
              </Table>
    
        </>
    
      )
    }
    // m2ex
    else {
      return (
        <></>
      );
    }


  

  }

export default SiteCommandInterface